import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaStop = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 4H4V20H20V4Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMediaStop.js.map